module.exports = __webpack_public_path__ + "media/images/booking_icon-3a8f829d81463b38c07c28d2f6bbba64.png";